<template>
  <div class="text-center d-flex">
    <v-menu
      bottom
      :close-on-content-click="closeOnContentClick"
      width="300"
      offset-y
      z-index="1"
      allow-overflow
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          hide-details
          height="10"
          class="caption"
          prepend-inner-icon="mdi-filter"
          :placeholder="$_strings.order.FILTER"
          outlined
          dense
          readonly
          v-bind="attrs"
          @click="closeOnContentClick = false"
          v-on="on"
        ></v-text-field>
      </template>
      <v-list
        width="300"
        min-height="150"
        max-height="500"
        class="overflow-auto"
      >
        <section v-for="item in itemsFilterAutoComplete" :key="item.id">
          <v-list-item>
            <v-list-item-title class="caption font-weight-bold">{{item.title}}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="pt-0 mt-0">
              <common-auto-complete-items
                :type="item.type"
                :searchName="item.searchName"
                :item-value="item.value"
                :item-text="item.text"
                hide-details
                height="10"
                v-model="form[item.vModel]"
                :placeholder="item.placeholder"
                dense
                outlined
                class="caption"
                clearable
                @updateItems="item.updateItems"
                :filter="pageFilters[item.filters]"
                :items="itemsFilter[item.items]"
              />
            </v-list-item-content>
          </v-list-item>
        </section>
        <section>
          <v-list-item>
            <v-list-item-title class="caption font-weight-bold">Nomor Kendaraan</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="pt-0 mt-0">
              <v-tooltip v-model="showTooltipLicensePlate" bottom>
                <template v-slot:activator="{ }">
                  <v-text-field
                    dense
                    outlined
                    class="caption"
                    placeholder="A 1234 BC"
                    v-model="form.companyTransportNo"
                    hide-details
                    @input="handleTooltipLicensePlate"
                    @blur="showTooltipLicensePlate = false"
                  />
                </template>
                <p>Ex: A 1234 BC</p>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </section>
        <section>
          <v-list-item>
            <v-list-item-title class="caption font-weight-bold">Status</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-content class="pt-0 mt-0">
              <section
                v-for="(chip, index) in latestStatus"
                :key="chip"
                class="mb-2"
              >
                <v-chip
                  close
                  small
                  @click:close="removeLatestStatus(index)"
                >
                  <strong>
                    {{ itemsLatestStatus.find((item) => item.value === chip) && itemsLatestStatus.find((item) => item.value === chip).text }}
                  </strong>
                </v-chip>
              </section>
              <v-autocomplete
                hide-details
                :items="itemsLatestStatus.filter((item) => !(latestStatus.find((ls) => ls === item.value)))"
                @change="addLatestStatus"
                v-model="status"
                class="caption"
                placeholder="Pilih status"
                dense
              ></v-autocomplete>
            </v-list-item-content>
          </v-list-item>
        </section>
        <section class="d-none">
          <v-list-item class="mb-0">
            <v-list-item-title class="caption font-weight-bold pb-0">Calculation Status</v-list-item-title>
          </v-list-item>
          <v-list-item class="pt-0">
            <v-list-item-content class="pt-0">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-checkbox
                    hide-details
                    class="caption pt-0 mt-0"
                    v-model="calculated"
                    @change="setIsCalculated('calculated')"
                  >
                    <template v-slot:label>
                      <span class="caption" id="checkboxLabel">Sudah di hitung</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    hide-details
                    class="caption pt-0 mt-0"
                    v-model="notCalculated"
                    @change="setIsCalculated('notCalculated')"
                  >
                    <template v-slot:label>
                      <span class="caption" id="checkboxLabel">Belum di hitung</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
          <v-list-item class="mb-0">
            <v-list-item-title class="caption font-weight-bold pb-0">POD Status</v-list-item-title>
          </v-list-item>
          <v-list-item class="pt-0">
            <v-list-item-content class="pt-0">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-checkbox
                    hide-details
                    class="caption pt-0 mt-0"
                    v-model="pod"
                    @change="setIsPod('pod')"
                  >
                    <template v-slot:label>
                      <span class="caption" id="checkboxLabel">Sudah POD</span>
                    </template>
                  </v-checkbox>
                </v-col>
                <v-col cols="12">
                  <v-checkbox
                    hide-details
                    class="caption pt-0 mt-0"
                    v-model="notPod"
                    @change="setIsPod('notPod')"
                  >
                    <template v-slot:label>
                      <span class="caption" id="checkboxLabel">Belum POD</span>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </section>
        <section class="pl-2 pr-2">
          <v-btn
            depressed
            color="primary"
            block
            @click="setFilter"
          >
            {{$_strings.common.APPLY}}
          </v-btn>
          <v-btn
            depressed
            class="mt-2 white--text"
            color="red"
            block
            @click="closeOnContentClick = true"
          >
            {{$_strings.common.CLOSE}}
          </v-btn>
        </section>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
  },
  mounted() {
    this.setItemsFromQueryString();
  },
  data() {
    return {
      status: '',
      calculated: this.$route.query.isCalculated === 'true',
      notCalculated: this.$route.query.isCalculated === 'false',
      pod: this.$route.query.isPod === 'true',
      notPod: this.$route.query.isPod === 'false',
      itemsFilterAutoComplete: [
        {
          id: 'customer',
          title: 'Nama Shipper',
          type: 'masterShipper',
          searchName: 'abbreviation',
          placeholder: 'Semua Shipper',
          text: 'abbreviation',
          value: 'id',
          vModel: 'shipperId',
          items: 'itemsCustomers',
          updateItems: this.updateCustomerItems,
          filters: 'customer',
        },
        {
          id: 'transporter',
          title: 'Rekanan 3PL',
          type: 'masterPartner',
          searchName: 'companyName',
          placeholder: 'Semua Rekanan 3PL',
          text: 'companyName',
          value: 'id',
          vModel: 'transporterId',
          items: 'itemsTransporter',
          updateItems: this.updateTransporterItems,
          filters: 'transporter',
        },
        {
          id: 'origin',
          title: 'Lokasi Asal',
          type: 'locations',
          searchName: 'name',
          placeholder: 'Semua Lokasi Asal',
          text: 'name',
          value: 'id',
          vModel: 'originLocationId',
          items: 'itemsLocation',
          updateItems: this.updateLocation,
          filters: 'location',
        },
        {
          id: 'destination',
          title: 'Lokasi Tujuan',
          type: 'locations',
          searchName: 'name',
          placeholder: 'Semua Lokasi Tujuan',
          text: 'name',
          value: 'id',
          vModel: 'destinationLocationId',
          items: 'itemsLocation',
          updateItems: this.updateLocation,
          filters: 'location',
        },
      ],
      itemsLatestStatus: [
        ...this.$_strings.order.STATUS_LIST_WAITING,
        ...this.$_strings.order.STATUS_LIST_PROCESS,
        ...this.$_strings.order.STATUS_LIST_COMPLETED,
      ],
      form: {
        shipperId: +this.$route.query.shipperId || '',
        transporterId: +this.$route.query.transporterId || '',
        originLocationId: +this.$route.query.originLocationId || '',
        destinationLocationId: +this.$route.query.destinationLocationId || '',
        companyTransportNo: this.$route.query.companyTransportNo || '',
        isCalculated: Boolean(this.$route.query.isCalculated) || '',
        isPod: Boolean(this.$route.query.isPod) || '',
      },
      itemsFilter: {
        itemsCustomers: [],
        itemsTransporter: [],
        itemsLocation: [],
      },
      pageFilters: {
        customer: {
          search: '',
          page: 0,
          size: 25,
          totalData: 0,
        },
        transporter: {
          search: '',
          page: 0,
          size: 25,
          totalData: 0,
        },
        location: {
          search: '',
          page: 0,
          size: 25,
          totalData: 0,
        },
      },
      closeOnContentClick: false,
      latestStatus: this.$route.query.latestStatus ? this.$route.query.latestStatus.split(',') : [],
      showTooltipLicensePlate: false,
    };
  },
  methods: {
    handleTooltipLicensePlate(value) {
      const pattern = /^([A-Za-z]{1,4})([\s]{1})([0-9]{1,5})([\s]{1})([A-Za-z]{0,3})$/;
      if (!pattern.test(value) && value) {
        this.showTooltipLicensePlate = true;
        return;
      }
      this.showTooltipLicensePlate = false;
    },
    setIsCalculated(value) {
      if (value === 'calculated' && this.notCalculated) this.notCalculated = !this[value];
      if (value === 'notCalculated' && this.calculated) this.calculated = !this[value];
      if (!this.notCalculated && !this.calculated) {
        this.form.isCalculated = '';
        return;
      }
      if (this.notCalculated) {
        this.form.isCalculated = false;
        return;
      }
      this.form.isCalculated = true;
    },
    setIsPod(value) {
      if (value === 'pod' && this.notPod) this.notPod = !this[value];
      if (value === 'notPod' && this.pod) this.pod = !this[value];
      if (!this.notPod && !this.pod) {
        this.form.isPod = '';
        return;
      }
      if (this.notPod) {
        this.form.isPod = false;
        return;
      }
      this.form.isPod = true;
    },
    setItemsFromQueryString() {
      const {
        shipperId,
        shipperName,
        transporterId,
        transporterName,
        originLocationId,
        origin,
        destinationLocationId,
        destination,
      } = this.$route.query;
      if (shipperId) {
        if (!(this.itemsFilter.itemsCustomers.find((item) => item.id === +shipperId))) {
          this.itemsFilter.itemsCustomers.push({
            id: +shipperId,
            abbreviation: shipperName,
          });
        }
      }
      if (transporterId) {
        if (!(this.itemsFilter.itemsTransporter.find((item) => item.id === +transporterId))) {
          this.itemsFilter.itemsTransporter.push({
            id: +transporterId,
            companyName: transporterName,
          });
        }
      }
      if (originLocationId) {
        if (!(this.itemsFilter.itemsLocation.find((item) => item.id === +originLocationId))) {
          this.itemsFilter.itemsLocation.push({
            id: +originLocationId,
            name: origin,
          });
        }
      }
      if (destinationLocationId) {
        if (!(this.itemsFilter.itemsLocation.find((item) => item.id === +destinationLocationId))) {
          this.itemsFilter.itemsLocation.push({
            id: +destinationLocationId,
            name: destination,
          });
        }
      }
    },
    updateCustomerItems(items) {
      this.itemsFilter.itemsCustomers = [...this.itemsFilter.itemsCustomers, ...items];
    },
    updateTransporterItems(items) {
      this.itemsFilter.itemsTransporter = [...this.itemsFilter.itemsTransporter, ...items];
    },
    updateLocation(items) {
      this.itemsFilter.itemsLocation = [...this.itemsFilter.itemsLocation, ...items];
    },
    addLatestStatus(value) {
      this.latestStatus.push(value);
    },
    removeLatestStatus(index) {
      this.latestStatus.splice(index, 1);
      this.status = '';
    },
    setFilter() {
      this.closeOnContentClick = true;
      const {
        shipperId,
        transporterId,
        originLocationId,
        destinationLocationId,
        companyTransportNo,
        isCalculated,
        isPod,
      } = this.form;
      const oldFilters = { ...this.filters };
      this.filters.shipperId = shipperId;
      this.filters.transporterId = transporterId;
      this.filters.originLocationId = originLocationId;
      this.filters.destinationLocationId = destinationLocationId;
      this.filters.companyTransportNo = companyTransportNo;
      this.filters.latestStatus = this.latestStatus.toString();
      this.filters.isCalculated = '';
      this.filters.isPod = '';
      if (typeof isCalculated === 'boolean') {
        this.filters.isCalculated = isCalculated;
      }
      if (typeof isPod === 'boolean') {
        this.filters.isPod = isPod;
      }
      if (JSON.stringify(oldFilters) !== JSON.stringify(this.filters)) {
        this.$router.replace({
          query: {
            ...this.$route.query,
            ...this.filters,
            origin: originLocationId ? this.itemsFilter.itemsLocation.find((item) => item.id === +originLocationId).name : '',
            destination: destinationLocationId ? this.itemsFilter.itemsLocation.find((item) => item.id === +destinationLocationId).name : '',
            shipperName: shipperId ? this.itemsFilter.itemsCustomers.find((item) => item.id === +shipperId).abbreviation : '',
            transporterName: transporterId ? this.itemsFilter.itemsTransporter.find((item) => item.id === +transporterId).companyName : '',
            page: 1,
          },
        });
      }
      this.$emit('applyFilters');
    },
  },
};
</script>
